export default "__VITE_ASSET__b2bd58f9__"